// @/components/layout/sidebar.jsx
// Main sidebar layout wrapper
// Drop-in replacement with collapsible navigation

import React from "react";

// Analytics
import { IntercomProvider } from "@/components/providers/IntercomProvider";

// Layout components
import LayoutMain, {
  LayoutContent,
  LayoutSidebar as LayoutSidebarInner,
  LAYOUT_DEFAULT,
  useLayout,
} from "./main";
import NavigationWidget from "./navigation-widget";
import MobileDrawer from "./mobile-drawer";
import MobileHeader from "./mobile-header";

// Cookie banner
import CookieBanner from '@/components/reusable/cookie-banner';

// ============================================================================
// LAYOUT SIDEBAR
// ============================================================================

/**
 * LayoutSidebar - Main layout with collapsible sidebar
 *
 * Features:
 * - Collapsible sidebar (expanded ↔ icon-only)
 * - Spring animations
 * - Click-to-expand when collapsed
 * - Mobile responsive with drawer navigation
 */
const LayoutSidebar = ({ children }) => {
  return (
    <IntercomProvider>
      <LayoutMain defaultExpanded={true} layout={LAYOUT_DEFAULT}>
        {/* Dynamic Sidebar (hidden on mobile) */}
        <LayoutSidebarInner>
          <NavigationWidget />
        </LayoutSidebarInner>

        {/* Mobile Navigation Drawer */}
        <MobileDrawer />

        {/* Main Content Column */}
        <div className="flex flex-1 flex-col min-w-0 overflow-hidden">
          <MobileHeaderWrapper />
          <LayoutContent>
            {children}
          </LayoutContent>
        </div>
      </LayoutMain>

      {/* Cookie Banner */}
      <CookieBanner />
    </IntercomProvider>
  );
};

// Conditionally render mobile header
const MobileHeaderWrapper = () => {
  const { isMobile } = useLayout();
  if (!isMobile) return null;
  return <MobileHeader />;
};

export default LayoutSidebar;
